import { ADD_NEW_PROPERTY_FAILURE,
  ADD_NEW_PROPERTY_REQUESTED,
  ADD_NEW_PROPERTY_SUCCESS,
  FETCH_SINGLE_PROPERTY_FAILURE,
  FETCH_SINGLE_PROPERTY_REQUESTED,
  FETCH_SINGLE_PROPERTY_SUCCESS,
  FETCH_MY_PROPERTIES_FAILURE,
  FETCH_MY_PROPERTIES_REQUESTED,
  FETCH_MY_PROPERTIES_SUCCESS,
  UPDATE_SINGLE_PROPERTY_FAILURE,
  UPDATE_SINGLE_PROPERTY_REQUESTED,
  UPDATE_SINGLE_PROPERTY_SUCCESS } from "../actions/properties-action-types";

const initialState = {
  addPropertyStatus: "pending",
  fetchPropertiesStatus: "pending",
  fetchSinglePropertyStatus: "pending",
  properties: [],
  updatePropertyStatus: "pending",
};

export default function myProperties(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case ADD_NEW_PROPERTY_FAILURE:
      return {
        ...state,
        addPropertyStatus: "failure",
      };

    case ADD_NEW_PROPERTY_REQUESTED:
      return {
        ...state,
        addPropertyStatus: "creating",
      };

    case ADD_NEW_PROPERTY_SUCCESS:
      return {
        ...state,
        addPropertyStatus: "success",
      };

    case FETCH_SINGLE_PROPERTY_FAILURE:
      return {
        ...state,
        fetchSinglePropertyStatus: "failure",
      };

    case FETCH_SINGLE_PROPERTY_REQUESTED:
      return {
        ...state,
        fetchSinglePropertyStatus: "fetching",
      };

    case FETCH_SINGLE_PROPERTY_SUCCESS: {
      const properties = [...state.properties];

      if (Array.isArray(payload)) {
        return {
          ...state,
          fetchSinglePropertyStatus: "success",
          properties: [],
        };
      }

      const index = properties.findIndex((singleProp) => singleProp.identifier === payload.identifier);

      if (index > -1) {
        properties[index] = {
          ...properties[index],
          ...payload,
        };
      } else {
        properties.push(payload);
      }

      return {
        ...state,
        fetchSinglePropertyStatus: "success",
        properties,
      };
    }

    case FETCH_MY_PROPERTIES_FAILURE:
      return {
        ...state,
        fetchPropertiesStatus: "failure",
      };

    case FETCH_MY_PROPERTIES_REQUESTED:
      return {
        ...state,
        fetchPropertiesStatus: "fetching",
      };

    case FETCH_MY_PROPERTIES_SUCCESS:
      return {
        ...state,
        fetchPropertiesStatus: "success",
        properties: payload,
      };

    case UPDATE_SINGLE_PROPERTY_FAILURE:
      return {
        ...state,
        updatePropertyStatus: "failure",
      };

    case UPDATE_SINGLE_PROPERTY_REQUESTED:
      return {
        ...state,
        updatePropertyStatus: "updating",
      };

    case UPDATE_SINGLE_PROPERTY_SUCCESS:
      return {
        ...state,
        updatePropertyStatus: "success",
      };

    default:
      return state;
  }
}
